import { render, staticRenderFns } from "./smartInform.vue?vue&type=template&id=146639da&scoped=true&"
import script from "./smartInform.vue?vue&type=script&lang=js&"
export * from "./smartInform.vue?vue&type=script&lang=js&"
import style0 from "./smartInform.vue?vue&type=style&index=0&id=146639da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146639da",
  null
  
)

export default component.exports